import React, { Fragment } from 'react';
import { string } from 'prop-types';
import { toUrl } from 'util/link';
import Head from 'next/head';

function AmpTwitterEmbed({ url }) {
  if (!url) {
    return null;
  }
  // extract tweet ID from url
  const parsed = toUrl(url);
  // Get last path segment
  const tweetId = parsed.pathname.match(/([^/]+)\/?$/)[1];
  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-twitter"
          key="amp-twitter-embed"
          src="https://cdn.ampproject.org/v0/amp-twitter-0.1.js"
        />
      </Head>
      <amp-twitter
        width="375"
        height="472"
        layout="responsive"
        data-tweetid={tweetId}
      />
    </Fragment>
  );
}

AmpTwitterEmbed.propTypes = {
  url: string
};

AmpTwitterEmbed.defaultProps = {
  url: undefined
};

export default AmpTwitterEmbed;
